export enum FEATURES {
  PARTICIPANTS = 'participants',
  PARTICIPANT_EDIT = 'participantsEdit',
  SITES = 'sites',
  STUDYUSERS = 'studyUsers',
}

export const FEATURE_FLAGS = [
  { name: FEATURES.PARTICIPANTS, isActive: true },
  { name: FEATURES.PARTICIPANT_EDIT, isActive: false },
  { name: FEATURES.SITES, isActive: false },
  { name: FEATURES.STUDYUSERS, isActive: false },
];

export const flagActive = (feature: string) => {
  return FEATURE_FLAGS.find(({ name }) => name === feature)?.isActive;
};
